/*
 * View for an topic attribute modal
 */

define(["marionette", "./template/attributesModalTemplate.html"], function (
  Marionette,
  AttributesModalTemplate,
) {
  var AttributesModalView = {};

  AttributesModalView.attributesModalLayout = Marionette.Layout.extend({
    template: AttributesModalTemplate,
    templateHelpers: {
      selectAttributeDataType: function (attributeModel, dataType) {
        if (attributeModel.get("id") && dataType.get("id") === attributeModel.get("dataType")) {
          return "selected";
        }
      },
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },

    events: {
      "change #attributeDataType": function () {
        this.trigger("change:attribute:dataType");
      },
    },

    getNameValue: function () {
      return this.$el.find("#attributeName").val();
    },

    getAttributeType: function () {
      return parseInt(this.$el.find("#attributeType").val());
    },

    getAttributeUnfilterable: function () {
      return this.$el.find("#attributeUnfilterable").prop("checked");
    },

    nameError: function (message) {
      this.$el
        .find("#attributeNameError")
        .append('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },

    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },

    getAttributeDataTypeId: function () {
      return parseInt(this.$el.find("#attributeDataType option:selected").val(), 10);
    },
  });

  return AttributesModalView;
});
